import React, { useEffect, useState } from "react"

import { Progress, type ProgressProps } from "antd"

import { NIRVANA_COLORS } from "../config/theme.config.ts"

export const ProgressElement: React.FunctionComponent<
    IProgressElementProps
> = ({
    containerClassName,
    constantSpin,
    percent,
    small,
    bordered,
    ...progressProps
}) => {
    const [innerPercent, setInnerPercent] = useState<number>(0)

    useEffect(() => {
        if (!constantSpin) {
            return
        }

        const intervalId = setInterval(() => {
            setInnerPercent(current => (current >= 100 ? 0 : current + 0.1))
        }, 10)

        return () => {
            try {
                clearInterval(intervalId)
            } catch (e) {}
        }
    }, [constantSpin])

    return (
        <div
            className={`
                relative
                ${containerClassName}
                ${small ? "progress-small" : ""}
                ${bordered ? "progress-bordered" : ""}
            `}
        >
            <Progress
                {...progressProps}
                percent={constantSpin ? innerPercent : percent}
                strokeColor={
                    progressProps.strokeColor || NIRVANA_COLORS.brand.primary
                }
                trailColor={
                    progressProps.trailColor || NIRVANA_COLORS.brand.lilacLight
                }
            />
        </div>
    )
}

interface IProgressElementProps extends ProgressProps {
    containerClassName?: string
    constantSpin?: boolean
    small?: boolean
    bordered?: boolean
}
